/**
 * Force CAD Currency - Server Side Fix (No Reload Loop)
 * Forces Shopify to load correct CAD prices from the server
 * APPLIES ONLY TO: manuka-honey-umf-30-mgo-1620 product in Canadian market
 * 
 * This fixes the root cause by ensuring the server sends CAD prices,
 * WITHOUT causing infinite reload loops.
 */

(function() {
  'use strict';

  // Check if this is the target product in CAD market
  const isTargetProduct = window.location.pathname.includes('/products/manuka-honey-umf-30-mgo-1620');
  const isCADMarket = window.location.pathname.startsWith('/en-ca');

  if (!isTargetProduct || !isCADMarket) {
    return;
  }


  // Prevent multiple initializations and redirect loops
  if (window.cadCurrencyEnforcerActive) {
    return;
  }
  
  // Check for redirect loop protection
  const redirectCount = parseInt(sessionStorage.getItem('redirect_count') || '0');
  if (redirectCount > 5) {
    console.error('🚫 Too many redirects detected, stopping currency enforcer');
    return;
  }
  
  // Increment redirect count
  sessionStorage.setItem('redirect_count', String(redirectCount + 1));
  
  window.cadCurrencyEnforcerActive = true;

  // ============================================
  // STEP 1: FORCE CAD CURRENCY IN ALL STORAGE
  // ============================================
  function forceCADCurrency() {
    // Mobile device detection
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                    window.innerWidth <= 768 || 
                    ('ontouchstart' in window);
    
    // Set Shopify currency cookies with long expiration
    const cookieOptions = isMobile ? 
      'path=/; max-age=31536000; SameSite=Lax; Secure' : 
      'path=/; max-age=31536000; SameSite=Lax';
    
    document.cookie = `currency=CAD; ${cookieOptions}`;
    document.cookie = `cart_currency=CAD; ${cookieOptions}`;
    document.cookie = `shopify_currency=CAD; ${cookieOptions}`;
    
    // Mobile-specific currency cookies
    if (isMobile) {
      document.cookie = `mobile_currency=CAD; ${cookieOptions}`;
      document.cookie = `device_currency=CAD; ${cookieOptions}`;
    }
    
    // Force in localStorage
    try {
      localStorage.setItem('currency', 'CAD');
      localStorage.setItem('cart_currency', 'CAD');
      localStorage.setItem('shopify_currency', 'CAD');
      
      // Mobile-specific storage
      if (isMobile) {
        localStorage.setItem('mobile_currency', 'CAD');
        localStorage.setItem('device_currency', 'CAD');
        localStorage.setItem('user_currency', 'CAD');
      }
    } catch (e) {
      console.warn('Could not set localStorage:', e);
    }
    
    // Force in sessionStorage
    try {
      sessionStorage.setItem('currency', 'CAD');
      sessionStorage.setItem('cart_currency', 'CAD');
      
      // Mobile-specific storage
      if (isMobile) {
        sessionStorage.setItem('mobile_currency', 'CAD');
        sessionStorage.setItem('device_currency', 'CAD');
      }
    } catch (e) {
      console.warn('Could not set sessionStorage:', e);
    }
    
  }

  // ============================================
  // STEP 2: FORCE SHOPIFY GLOBAL CURRENCY
  // ============================================
  function forceShopifyCurrency() {
    // Force Shopify.currency if it exists
    if (typeof Shopify !== 'undefined') {
      if (Shopify.currency) {
        Shopify.currency.active = 'CAD';
        Shopify.currency.rate = '1.0'; // CAD to CAD rate
      }
    }

    // Force DoublyGlobalCurrency if present (used by some currency apps)
    if (typeof DoublyGlobalCurrency !== 'undefined') {
      DoublyGlobalCurrency.currentCurrency = 'CAD';
    }

    // Force Currency global if present
    if (typeof Currency !== 'undefined' && Currency.currentCurrency) {
      Currency.currentCurrency = 'CAD';
    }
  }

  // ============================================
  // STEP 3: INTERCEPT FETCH REQUESTS
  // ============================================
  function interceptFetchRequests() {
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      let url = args[0];
      let options = args[1] || {};
      
      // Mobile device detection
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                      window.innerWidth <= 768 || 
                      ('ontouchstart' in window);
      
      // Skip authentication and other critical requests (more comprehensive)
      if (typeof url === 'string' && (
        url.includes('/authentication/') ||
        url.includes('/oauth/') ||
        url.includes('/callback') ||
        url.includes('/login') ||
        url.includes('/logout') ||
        url.includes('/account/') ||
        url.includes('/customer/') ||
        url.includes('/quicklink') ||
        url.includes('/br-links') ||
        url.includes('account.newzealandhoneyco.com') ||
        url.includes('oauth/authorize') ||
        url.includes('client_id=') ||
        url.includes('consent_id=') ||
        url.includes('redirect_uri=') ||
        url.includes('response_type=') ||
        url.includes('scope=') ||
        url.includes('state=') ||
        url.includes('nonce=') ||
        url.includes('locale=') ||
        url.includes('region_country=') ||
        // Skip API requests that might cause issues
        url.includes('/api/') ||
        url.includes('userway.org') ||
        url.includes('product-info.js') ||
        url.includes('quicklink') ||
        // Skip any external domain requests
        !url.startsWith('/') && !url.startsWith(window.location.origin)
      )) {
        // Skip these requests entirely
        return originalFetch.apply(this, args);
      }
      
      // Intercept ONLY JSON/cart API requests. Never touch full HTML page fetches (e.g., product-info.js)
      const headers = options && options.headers ? (options.headers instanceof Headers ? Object.fromEntries(options.headers.entries()) : options.headers) : {};
      const acceptHeader = (headers['Accept'] || headers['accept'] || '').toString();
      const looksLikeHtmlRequest = (typeof url === 'string') && (!url.includes('.json')) && (acceptHeader.includes('text/html') || url.includes('/products/'));

      // For same-origin product HTML fetches, append CAD params safely without touching auth/external
      if (looksLikeHtmlRequest) {
        try {
          const htmlUrl = new URL(url, window.location.origin);
          const isSameOrigin = htmlUrl.origin === window.location.origin;
          const isProductHtml = htmlUrl.pathname.startsWith('/en-ca/products/');
          const isAuth = htmlUrl.href.includes('/authentication/') || htmlUrl.href.includes('/oauth/') || htmlUrl.href.includes('/account/');
          if (isSameOrigin && isProductHtml && !isAuth) {
            htmlUrl.searchParams.set('currency', 'CAD');
            htmlUrl.searchParams.set('cart_currency', 'CAD');
            htmlUrl.searchParams.set('country', 'CA');
            // Cache-buster to avoid stale cached HTML on mobile Safari
            htmlUrl.searchParams.set('_cad_fix', '1');
            htmlUrl.searchParams.set('_ts', String(Date.now()));
            args[0] = htmlUrl.toString();
            // Do not add headers to avoid changing Accept content negotiation for HTML
          }
        } catch (e) {
          // If we fail to parse/adjust, just fall through untouched
        }
        return originalFetch.apply(this, args);
      }

      if (typeof url === 'string' && (
        // Cart add/update endpoints
        url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change') ||
        // JSON endpoints where currency matters
        url.includes('.json') || url.includes('/cart.js') || url.includes('/products.json') || url.includes('/variants.json')
      )) {
        try {
          const urlObj = new URL(url, window.location.origin);
          
          // Force CAD in query parameters
          urlObj.searchParams.set('currency', 'CAD');
          urlObj.searchParams.set('cart_currency', 'CAD');
          urlObj.searchParams.set('country', 'CA');
          
          // Mobile-specific parameters
          if (isMobile) {
            urlObj.searchParams.set('mobile_currency', 'CAD');
            urlObj.searchParams.set('device_currency', 'CAD');
            urlObj.searchParams.set('user_currency', 'CAD');
          }
          
          // Update the URL
          args[0] = urlObj.toString();
          
          // Also add currency to headers if possible
          if (!options.headers) {
            options.headers = {};
          }
          
          if (typeof options.headers === 'object' && !(options.headers instanceof Headers)) {
            options.headers['X-Currency'] = 'CAD';
            options.headers['X-Country'] = 'CA';
            
            if (isMobile) {
              options.headers['X-Mobile-Currency'] = 'CAD';
              options.headers['X-Device-Currency'] = 'CAD';
            }
          }
          
          args[1] = options;
          
        } catch (e) {
          console.warn('Failed to modify fetch URL:', e);
        }
      }
      
      // Call original fetch
      return originalFetch.apply(this, args);
    };
    
  }

  // ============================================
  // STEP 4: INTERCEPT XHR REQUESTS
  // ============================================
  function interceptXHRRequests() {
    const originalOpen = XMLHttpRequest.prototype.open;
    
    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      // Skip authentication and other critical requests (more comprehensive)
      if (typeof url === 'string' && (
        url.includes('/authentication/') ||
        url.includes('/oauth/') ||
        url.includes('/callback') ||
        url.includes('/login') ||
        url.includes('/logout') ||
        url.includes('/account/') ||
        url.includes('/customer/') ||
        url.includes('/quicklink') ||
        url.includes('/br-links') ||
        url.includes('account.newzealandhoneyco.com') ||
        url.includes('oauth/authorize') ||
        url.includes('client_id=') ||
        url.includes('consent_id=') ||
        url.includes('redirect_uri=') ||
        url.includes('response_type=') ||
        url.includes('scope=') ||
        url.includes('state=') ||
        url.includes('nonce=') ||
        url.includes('locale=') ||
        url.includes('region_country=') ||
        // Skip API requests that might cause issues
        url.includes('/api/') ||
        url.includes('userway.org') ||
        url.includes('product-info.js') ||
        url.includes('quicklink') ||
        // Skip any external domain requests
        !url.startsWith('/') && !url.startsWith(window.location.origin)
      )) {
        // Skip these requests entirely
        return originalOpen.call(this, method, url, ...rest);
      }
      
      if (typeof url === 'string' && (
        // Cart add/update endpoints
        url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change') ||
        // JSON endpoints where currency matters
        url.includes('.json') || url.includes('/cart.js') || url.includes('/products.json') || url.includes('/variants.json')
      )) {
        try {
          const urlObj = new URL(url, window.location.origin);
          urlObj.searchParams.set('currency', 'CAD');
          urlObj.searchParams.set('cart_currency', 'CAD');
          urlObj.searchParams.set('country', 'CA');
          url = urlObj.toString();
        } catch (e) {
          console.warn('Failed to modify XHR URL:', e);
        }
      }
      
      return originalOpen.call(this, method, url, ...rest);
    };
    
  }

  // ============================================
  // STEP 5: HANDLE VARIANT CHANGES
  // ============================================
  function setupVariantMonitoring() {
    // Monitor variant changes
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name="id"], select[name="id"]')) {
        
        // Re-enforce currency settings
        forceCADCurrency();
        forceShopifyCurrency();
      }
    });

    // Monitor clicks on variant selectors
    document.addEventListener('click', (e) => {
      if (e.target.matches('.product-form__option-element, .swatch, [data-variant-id]')) {
        forceCADCurrency();
        forceShopifyCurrency();
      }
    });
    
    // Mobile-specific monitoring (only on mobile devices)
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                    window.innerWidth <= 768 || 
                    ('ontouchstart' in window);
    
    if (isMobile) {
      // Mobile touch events
      document.addEventListener('touchstart', (e) => {
        if (e.target.matches('.product-form__option-element, .swatch, [data-variant-id], .mobile-variant, .touch-variant')) {
          forceCADCurrency();
          forceShopifyCurrency();
        }
      });
      
      // Monitor DOM changes for mobile-specific price updates
      if (window.MutationObserver) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && (
                  node.matches && (
                    node.matches('.price, [class*="price"], .money') ||
                    node.matches('[data-mobile-price], .mobile-price')
                  )
                )) {
                  setTimeout(() => {
                    forceCADCurrency();
                    forceShopifyCurrency();
                  }, 100);
                }
              });
            }
          });
        });
        
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
        
      }
      
    }
    
  }

  // ============================================
  // STEP 6: MAINTAIN CAD CURRENCY (MOBILE ENHANCED)
  // ============================================
  function maintainCADCurrency() {
    // Mobile device detection
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                    window.innerWidth <= 768 || 
                    ('ontouchstart' in window) ||
                    /Mobile|Tablet/i.test(navigator.userAgent);
    
    // Re-check and re-set currency periodically (more frequent on mobile)
    const interval = isMobile ? 2000 : 3000;
    
    setInterval(() => {
      try {
        const localCurrency = localStorage.getItem('currency');
        const sessionCurrency = sessionStorage.getItem('currency');
        
        // Mobile-specific currency checks
        if (isMobile) {
          const mobileCurrency = localStorage.getItem('mobile_currency');
          const deviceCurrency = localStorage.getItem('device_currency');
          
          if (localCurrency !== 'CAD' || sessionCurrency !== 'CAD' || 
              mobileCurrency !== 'CAD' || deviceCurrency !== 'CAD') {
            console.warn('📱 Mobile: Currency was changed, re-enforcing CAD');
            forceCADCurrency();
            forceShopifyCurrency();
          }
        } else {
          if (localCurrency !== 'CAD' || sessionCurrency !== 'CAD') {
            console.warn('⚠️ Currency was changed, re-enforcing CAD');
            forceCADCurrency();
            forceShopifyCurrency();
          }
        }
      } catch (e) {
        // Ignore storage errors
      }
    }, interval);
    
  }

  // ============================================
  // STEP 7: SAFE CURRENCY DETECTION (NO RELOAD)
  // ============================================
  function checkCurrencyAndFix() {
    // Wait for page to fully load
    setTimeout(() => {
      // Check if we've already attempted fixes
      const fixAttempts = parseInt(sessionStorage.getItem('cad_fix_attempts') || '0');
      
      if (fixAttempts >= 3) {
        return;
      }
      
      // Enhanced mobile device detection
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                      window.innerWidth <= 768 || 
                      ('ontouchstart' in window) ||
                      /Mobile|Tablet/i.test(navigator.userAgent);
      
      
      // Comprehensive price element detection (mobile gets more selectors)
      const baseSelectors = `.price, [class*="price"], .money, [data-price], .product-price, .variant-price`;
      const mobileSelectors = `${baseSelectors},
        .mobile-price, .mobile-money, [data-mobile-price],
        .responsive-price, .responsive-money,
        .shopify-price, .shopify-money,
        .theme-price, .theme-money,
        .product-form__price, .product-single__price,
        .price-range, .price-from, .price-to,
        .compare-price, .sale-price, .regular-price,
        .price-wrapper, .money-wrapper, .currency-wrapper,
        [class*="money"], [class*="currency"], [class*="amount"],
        .product__price, .product-price-current, .product-price-original,
        .variant-price, .variant-price-current, .variant-price-original,
        .cart-item-price, .line-item-price, .total-price`;
      
      const priceElements = document.querySelectorAll(isMobile ? mobileSelectors : baseSelectors);
      
      let hasUSD = false;
      let usdCount = 0;
      let cadCount = 0;
      
      priceElements.forEach((el, index) => {
        const text = el.textContent || '';
        const html = el.innerHTML || '';
        
        // Debug logging for mobile
        if (isMobile && index < 5) { // Log first 5 elements for debugging
        }
        
        // Enhanced CAD detection (more flexible patterns)
        const cadPatterns = [
          /\$\d+(?:\.\d{2})?\s*CAD/i,
          /CAD\s*\$\d+(?:\.\d{2})?/i,
          /C\$\d+(?:\.\d{2})?/i,
          /Canadian\s*\$?\d+(?:\.\d{2})?/i,
          /(?:^|\s)\$\d+(?:\.\d{2})?\s*CAD/i
        ];
        
        const hasCAD = cadPatterns.some(pattern => pattern.test(text)) || 
                      (text.includes('$') && text.includes('CAD'));
        
        if (hasCAD) {
          cadCount++;
          if (isMobile) {
          }
        }
        
        // Enhanced USD detection (more flexible patterns)
        const usdPatterns = [
          /\$\d+(?:\.\d{2})?\s*USD/i,
          /USD\s*\$\d+(?:\.\d{2})?/i,
          /US\$\d+(?:\.\d{2})?/i,
          /American\s*\$?\d+(?:\.\d{2})?/i,
          /(?:^|\s)\$\d+(?:\.\d{2})?\s*USD/i
        ];
        
        const hasUSD = usdPatterns.some(pattern => pattern.test(text)) || 
                      (text.includes('$') && text.includes('USD'));
        
        // Mobile-specific: Check for dollar signs without currency indicators
        const hasDollarSign = text.match(/\$\d+(?:\.\d{2})?/);
        const isMobileUSD = isMobile && hasDollarSign && !text.includes('CAD') && !text.includes('USD');
        
        if (hasUSD || isMobileUSD) {
          console.warn(`⚠️ USD price detected (${isMobile ? 'Mobile' : 'Desktop'}):`, text.substring(0, 50));
          hasUSD = true;
          usdCount++;
        }
      });
      
      // Only proceed if we have USD prices AND no CAD prices (mixed currency issue)
      if (hasUSD && usdCount > 0 && cadCount === 0) {
        
        // Increment fix attempts
        sessionStorage.setItem('cad_fix_attempts', String(fixAttempts + 1));
        
        // Try to force server-side currency change without reload
        try {
          // Force currency in URL parameters
          const currentUrl = new URL(window.location);
          currentUrl.searchParams.set('currency', 'CAD');
          currentUrl.searchParams.set('cart_currency', 'CAD');
          currentUrl.searchParams.set('country', 'CA');
          
          // Update URL without reload
          window.history.replaceState({}, '', currentUrl.toString());
          
          // Re-enforce all currency settings
          forceCADCurrency();
          forceShopifyCurrency();
          
          
          // Check again after a delay
          setTimeout(() => {
            checkCurrencyAndFix();
          }, 1000);
          
        } catch (e) {
          console.warn('Failed to update URL parameters:', e);
        }

        // Mobile hard-fix: as a last resort on real devices, do a single full reload with CAD params
        try {
          const isMobileHardFix = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          const hardfixDone = sessionStorage.getItem('cad_mobile_hardfix_done') === '1';
          if (isMobileHardFix && !hardfixDone && fixAttempts >= 2) {
            const hardUrl = new URL(window.location.href);
            hardUrl.searchParams.set('currency', 'CAD');
            hardUrl.searchParams.set('cart_currency', 'CAD');
            hardUrl.searchParams.set('country', 'CA');
            hardUrl.searchParams.set('_cad_mobile_hardfix', '1');
            sessionStorage.setItem('cad_mobile_hardfix_done', '1');
            window.location.replace(hardUrl.toString());
          }
        } catch(_) {}
      } else if (cadCount > 0) {
        // Reset fix attempts on success
        sessionStorage.removeItem('cad_fix_attempts');
      } else {
        // Reset fix attempts on success
        sessionStorage.removeItem('cad_fix_attempts');
      }
      
      // Mobile-specific: Additional check after a longer delay
      if (isMobile) {
        setTimeout(() => {
          const additionalElements = document.querySelectorAll('.price, [class*="price"], .money, [data-price]');
          let additionalUSD = false;
          
          additionalElements.forEach(el => {
            const text = el.textContent || '';
            if (text.match(/\$\d+(?:\.\d{2})?/) && !text.includes('CAD') && !text.includes('USD')) {
              console.warn('📱 Mobile: Additional USD price detected:', text.substring(0, 50));
              additionalUSD = true;
            }
          });
          
          if (additionalUSD) {
            forceCADCurrency();
            forceShopifyCurrency();
          }
        }, 5000); // Check again after 5 seconds on mobile
      }
    }, isMobile ? 3000 : 2000); // Longer delay for mobile
  }

  // ============================================
  // STEP 8: CLEANUP AND RESET COUNTERS
  // ============================================
  function cleanupAndReset() {
    // Reset redirect count on successful page load
    setTimeout(() => {
      sessionStorage.removeItem('redirect_count');
    }, 5000);
  }

  // ============================================
  // INITIALIZE EVERYTHING IN CORRECT ORDER
  // ============================================
  function initialize() {
    
    // Step 1: Force CAD immediately (before any requests)
    forceCADCurrency();
    forceShopifyCurrency();
    
    // Step 2: Set up request interception (before page makes requests)
    interceptFetchRequests();
    interceptXHRRequests();
    
    // Step 3: Set up variant monitoring
    setupVariantMonitoring();
    
    // Step 4: Maintain CAD currency
    maintainCADCurrency();
    
    // Step 5: Check currency and fix without reload
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkCurrencyAndFix);
    } else {
      checkCurrencyAndFix();
    }
    
    // Mobile: observe large DOM swaps and re-enforce CAD
    (function installMobileObserver() {
      try {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                        window.innerWidth <= 768 || 
                        ('ontouchstart' in window) ||
                        /Mobile|Tablet/i.test(navigator.userAgent);
        if (!isMobile || !window.MutationObserver) return;
        const observer = new MutationObserver((mutations) => {
          let significantChange = false;
          for (const m of mutations) {
            if (m.type === 'childList' && (m.addedNodes?.length || m.removedNodes?.length)) {
              significantChange = true; break;
            }
          }
          if (significantChange) {
            // Re-enforce quickly after DOM swap
            setTimeout(() => {
              forceCADCurrency();
              forceShopifyCurrency();
              // Run currency checker again
              checkCurrencyAndFix();
            }, 150);
          }
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
      } catch (e) {}
    })();

    // Step 6: Cleanup and reset counters
    cleanupAndReset();
    
    // Handle Safari bfcache and tab visibility on real devices
    window.addEventListener('pageshow', (evt) => {
      if (evt.persisted) {
        forceCADCurrency();
        forceShopifyCurrency();
        checkCurrencyAndFix();
      }
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        forceCADCurrency();
        forceShopifyCurrency();
        checkCurrencyAndFix();
      }
    });

  }

  // Start everything
  initialize();

})();